import DefaultMap from '../../../components/Map/DefaultMap'
import useRideByIdQuery from '../../../hooks/useRideByIdQuery'
import { useQuery } from '@tanstack/react-query'
import { driverLocation, driverWaypoints } from '../../../services/rides/rides'
import DriverLocation from './DriverLocation'
import RideMarkers from './RideMarkers'
import DriverWaypoints from './DriverWaypoints'
import './map.scss'
import Center from './Center'

const Map = () => {
  const { data: ride } = useRideByIdQuery()

  const isRideActive = ride ? ['assigned', 'accepted', 'arriving', 'in_progress'].includes(ride.ride.status) : false

  const { data: driverLocationResponse } = useQuery({
    refetchInterval: data => {
      if (!data) return false
      return 5000
    },
    queryKey: ['driver-location', ride?.ride.id || null, ride?.ride.status],
    retry: false,
    queryFn: () => {
      if (!ride?.ride.id || !isRideActive) return null
      return driverLocation(ride?.ride.id)
    }
  })

  const { data: driverWaypointsResponse } = useQuery({
    refetchInterval: data => {
      if (!data) return false
      return 15000
    },
    queryKey: ['driver-waypoints', ride?.ride.driver_id || null, ride?.ride.status],
    retry: false,
    queryFn: () => {
      if (!ride?.ride.driver_id || !isRideActive) return null
      return driverWaypoints(ride?.ride.driver_id)
    }
  })

  return (
    <DefaultMap className="map">
      <Center
        driver={driverLocationResponse?.driver || null}
        ride={ride?.ride || null} />
      <DriverWaypoints
        selectedRideId={ride?.ride.id || null}
        driverPolyline={driverWaypointsResponse?.polyline || null}
        waypoints={driverWaypointsResponse?.waypoints || []} />
      <DriverLocation driver={driverLocationResponse?.driver || null} />
      <RideMarkers
        waypoints={driverWaypointsResponse?.waypoints || []}
        ride={ride?.ride || null} />
    </DefaultMap>
  )
}

export default Map

